import(/* webpackMode: "eager" */ './park-search.scss')
import { dom } from '@fortawesome/fontawesome-svg-core'
import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import('../../services/google-maps-optimizer.js')

// See: https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
const googleMapsApi = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: '3.exp',
  libraries: ['places'],
})

googleMapsApi.load().then(async (google) => {
  const { default: typeahead } = await import('../location-typeahead/location-typeahead')
  const { default: moment } = await import('moment')
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  const { default: InfoBox } = await import('../../plugins/infobox/infobox.js')
  const { default: CustomMarker } = await import('../../plugins/customMarker/customMarker.js')
  const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import('../../plugins/semantic/form')]).then(() => {
    Promise.all([
      import('../../scripts/dbs/dbs.semantic.form'),
      import('../../scripts/dbs/dbs.utilities.querystring'),
      import('../../plugins/semantic/input.scss'),
      import('../../plugins/daterangepicker/daterangepicker'),
      import('../../plugins/daterangepicker/daterangepicker.scss'),
      import('../../plugins/semantic/accordion'),
      import('../../plugins/semantic/accordion.css'),
      import('../../plugins/semantic/api'),
      import('../../plugins/semantic/checkbox'),
      import('../../plugins/semantic/checkbox.css'),
      import('../../plugins/semantic/dimmer'),
      import('../../plugins/semantic/dimmer.scss'),
      import('../../plugins/semantic/dropdown'),
      import('../../plugins/semantic/dropdown.scss'),
      import('../../plugins/semantic/icon.css'),
      import('../../plugins/semantic/label.css'),
      import('../../plugins/semantic/modal'),
      import('../../plugins/semantic/modal.scss'),
      import('../../plugins/semantic/popup'),
      import('../../plugins/semantic/popup.css'),
      import('../../plugins/semantic/search'),
      import('../../plugins/semantic/search.scss'),
      import('../../plugins/semantic/table.css'),
      import('../../plugins/semantic/transition.css'),
      import('../../plugins/semantic/transition.js'),
      import('../guest-selector/guest-selector'),
      import('../guest-selector/guest-selector.scss'),
      import('../location-typeahead/location-typeahead.scss'),
    ]).then(() => {
      $('.widget.park-search').each(function (i, el) {
        $(el).data(
          'widget',
          new ParkSearch(el, google, Swiper, typeahead, moment, CustomMarker, InfoBox, AdvancedMarkerElement),
        )
        $(el).data('widget').init()
      })
    })
  })
})

function ParkSearch(el, google, Swiper, typeahead, moment, CustomMarker, InfoBox, AdvancedMarkerElement) {
  const self = this
  self.doingInitialSearch = true;
  self.$el = $(el)
  self.optimizer = window.googleMapsOptimizer

  self.isDhpTheme = $('html').hasClass('dhp-theme') || $('body').hasClass('dhp-theme')
  self.qs = new dbs.utilities.querystring()

  self.tomorrowDate = new Date(new Date().setDate(new Date().getDate() + 1))
  self.todayDate = new Date()
  self.maxDate = new moment().add(1, 'y').toDate()

  // Not used.
  // self.autoCompleteService = new google.maps.places.AutocompleteService()

  self.typeahead = new typeahead(self.$el.find('.location-typeahead'), google)
  self.typeahead.init()

  self.searchForm = new dbs.form.genericForm()
  self.searchForm.init(self.$el.find('.search-form'))

  self.$mobileFiltersEl = self.$el.find('.mobile-filters')
  self.mobileFiltersForm = new dbs.form.genericForm()
  self.mobileFiltersForm.init(self.$mobileFiltersEl)

  self.isGeoLocationSearch = false
  if (self.qs.getParameter('isGeoLocationSearch')) {
    self.isGeoLocationSearch = true;
  }



  self.showGeoLocationUnavailableError = () => {
    $('.geolocation-popup').modal({ closable: true }).modal('show')
  }
  self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_error', self.showGeoLocationUnavailableError)

  self.handleGeoLocationPositionResponse = (data) => {
    if (data == null) {
      return; // no data, ignore I guess
    }
    self.filters.query = ''
    self.filters.states = '';
    //self.removeStateFirstAttempt = 5; // Definitely remove state filter if it's not there
    self.idlesBeforeQueryClear = 0; // Prevents subsequent searches from clearing early
    self.typeahead.el.find('.clear-button').trigger('click'); // clear out any location search if there was any

    self.isGeoLocationSearch = true // after the clear, as clearing typeahead sets geolocation to false
    // Uncheck any state boxes if they're checked, otherwise it won't work
    if (self.$el.find('input[name="parkState[]"]:checked').length > 0) {
      self.$el.find('input[name="parkState[]"]:checked').each((k, element) => {
        $(element).prop('checked', false)
      });
    }
    self.updateFilterButtons();
    self.filters.lat = data.coords.latitude;
    self.filters.lng = data.coords.longitude;
    const newlatlng = new google.maps.LatLng(self.filters.lat, self.filters.lng);
    self.map.setZoom(8); // Default zoom if viewport is not available
    self.map.setCenter(newlatlng);
    //self.performSearch(true);
    self.updateParkTileDistanceAndOrder()
  }
  self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_response', self.handleGeoLocationPositionResponse)

  self.properties = []
  self.totalCount = 0
  self.offset = 0
  self.pageSize = 0
  self.defaultPageSize = 1000

  // Determine which results template we use
  self.parkTileDetailsTemplate = require('./park-tile-details.hbs')
  self.markerTemplate = require('./marker.hbs')
  // TODO since we have merged 'park-map-vs.js' into this file, we do not need window. prefix to share properties.
  window.parkSearch = window.parkSearch || {}
  window.parkSearch.properties = window.parkSearch.properties || []
  window.parkSearch.prices = window.parkSearch.prices || []
  window.mapActive = false
  window.mapIdle = false

  self.populateMap_properties = []
  self.populateMap_totalCount = false
  self.populateMap_currentOffset = 0

  self.populateMap_localStorageKey = 'populateMap_properties'

  self.prices = []
  self.markers = []
  self.customMarkers = []
  self.bounds = new google.maps.LatLngBounds()
  self.infoboxTemplate = require('./infobox.hbs')
  self.parkTileTemplate = require('./park-tile.hbs')

  window.mapActive = false
  self.map = null
  self.populateMap_event_key = 'populateMap:populateProperties'


  //self.defaultCenterLocation = { lat: -28.214525963376698, lng: 133.550052 }

  //self.defaultCenterLocation = { lat: -27.49826182015982, lng: 132.550052 }
  //self.defaultCenterLocation = { lat: -27.480906, lng: 134.636024 }
  self.defaultCenterLocation = { lat: -27.49826182015982, lng: 133.7131724375 }
  self.defaultZoomLevel = 5
  self.australiaBounds = {
    north: -8.267029,
    south: -43.88869,
    west: 103.091866,
    east: 161.008238,
  }
  // TODO BIG
  // Fix double "back' pushState problem, zoom is being added after, so getting back requires double clicks
  // On arriving on just /parks and searching it still defaults to center of Australia

  self.getStateRouteNameFromFilterValue = (value) => {
    switch (value) {
      case 'nsw':
        return 'new-south-wales';
      case 'qld':
        return 'queensland';
      case 'vic':
        return 'victoria';
      case 'sa':
        return 'south-australia';
      case 'wa':
        return 'western-australia';
      case 'tas':
        return 'tasmania';
      case 'nt':
        return 'northern-territory';
      case 'act':
        return 'australian-capital-territory';
    }
  }
  self.getStateFilterValueFromName = (stateName) => {
    switch (stateName) {
      case 'new-south-wales':
      case 'New South Wales':
      case 'nsw':
        return 'nsw';
      case 'victoria':
      case 'Victoria':
      case 'vic':
        return 'vic';
      case 'queensland':
      case 'Queensland':
      case 'qld':
        return 'qld';
      case 'south-australia':
      case 'South Australia':
      case 'sa':
        return 'sa';
      case 'western-australia':
      case 'Western Australia':
      case 'wa':
        return 'wa';
      case 'tasmania':
      case 'Tasmania':
      case 'tas':
        return 'tas';
      case 'northern-territory':
      case 'Northern Territory':
      case 'nt':
        return 'nt'
      case 'australian-capital-territory':
      case 'Australian Capital Territory':
      case 'act':
        return 'act';
      default:
        return '';
    }
  }
  self.stateFilterValues = () => {
    return [
      'nsw',
      'vic',
      'qld',
      'sa',
      'wa',
      'tas',
      'nt',
      'act',
    ]
  }

  self.getStateUrlArray = () => {
    return [
      'new-south-wales',
      'victoria',
      'queensland',
      'south-australia',
      'western-australia',
      'tasmania',
      'northern-territory',
      'australian-capital-territory',
    ]
  }

  self.getDefaultFilters = () => {
    // Check if state is set in the URL
    let states = '';
    if (self.getStateUrlArray().some(state => window.location.pathname.includes(state))) {
      states = self.getStateFilterValueFromName(self.getStateUrlArray().find(state => window.location.pathname.includes(state)));

    }
    // If it's already in the query params for some reason, that overrides the /parks/{state}
    if (self.qs.getParameter('states') !== null && typeof self.qs.getParameter('states') !== 'undefined') {
      if (self.qs.getParameter('states').includes("|")) {
        // TODO Test this
        states = self.qs.getParameter('states').split('|')
        // TODO filter and ensure they're valid here
        states = states.filter(state => self.stateFilterValues().includes(state))
        states = states.join('|');
        // Multiple states, split and break into array
      } else {
        states = self.qs.getParameter('states'); // Just one state
      }
    }

    var arrive = (self.qs.getParameter('arrive') !== null && typeof self.qs.getParameter('arrive') !== 'undefined')
      ? self.qs.getParameter('arrive') : moment(self.todayDate).format('YYYY-MM-DD')
    if (arrive < moment(self.todayDate).format('YYYY-MM-DD')) {
      arrive = moment(self.todayDate).format('YYYY-MM-DD');
    }
    var depart = (self.qs.getParameter('depart') !== null && typeof self.qs.getParameter('depart') !== 'undefined')
      ? self.qs.getParameter('depart')
      : moment(self.tomorrowDate).format('YYYY-MM-DD')
    // Check if it's in the past and set it to tomorrow if that's the case
    if (depart < moment(self.tomorrowDate).format('YYYY-MM-DD')) {
      depart = moment(self.tomorrowDate).format('YYYY-MM-DD');
    }
    return {
      states: states ?? '',
      arrive: arrive,
      depart: depart,
      adults:
        (self.qs.getParameter('adults') !== null && typeof self.qs.getParameter('adults') !== 'undefined')
          ? self.qs.getParameter('adults') : 2,
      kids:
        (self.qs.getParameter('kids') !== null && typeof self.qs.getParameter('kids') !== 'undefined')
          ? self.qs.getParameter('kids') : 0,
      infants:
        (self.qs.getParameter('infants') !== null && typeof self.qs.getParameter('infants') !== 'undefined')
          ? self.qs.getParameter('infants') : 0,
      experiences:
        (self.qs.getParameter('experiences') !== null && typeof self.qs.getParameter('experiences') !== 'undefined')
          ? self.qs.getParameter('experiences') : '',
      features: (self.qs.getParameter('features') !== null && typeof self.qs.getParameter('features') !== 'undefined')
        ? self.qs.getParameter('features') : '',
      pets: (self.qs.getParameter('pets') !== null && typeof self.qs.getParameter('pets') !== 'undefined')
        ? self.qs.getParameter('pets') : '',
      query:
        (self.qs.getParameter('query') !== null && typeof self.qs.getParameter('query') !== 'undefined')
          ? self.qs.getParameter('query') : '',
      lat:
        (self.qs.getParameter('lat') !== null && typeof self.qs.getParameter('lat') !== 'undefined')
          ? self.qs.getParameter('lat') : self.defaultCenterLocation.lat,
      lng:
        (self.qs.getParameter('lng') !== null && typeof self.qs.getParameter('lng') !== 'undefined')
          ? self.qs.getParameter('lng') : self.defaultCenterLocation.lng,
      zoom:
        (self.qs.getParameter('zoom') !== null && typeof self.qs.getParameter('zoom') !== 'undefined')
          ? self.qs.getParameter('zoom') : self.defaultZoomLevel,
    }
  }



  self.$loader = self.$el.find('.loader');
  self.isLoading = false;
  self.showLoading = () => {
    if (!self.isLoading) {
      self.isLoading = true;
      self.$loader.fadeIn(100);
    }
  }
  self.finishLoading = () => {
    if (self.isLoading) {
      self.isLoading = false;
      self.$loader.fadeOut(100);
    }
  }
  // Initialize the loader while everything else is loading in the background
  self.showLoading();
  self.filters = self.getDefaultFilters()

  // First load
  window.dbs.globalEvents.subscribe(self.populateMap_event_key, function (properties) {


    self.createBaseMapPins()
    self.createParkTiles()
    self.initParkTilesImageSlider()
    if (!self.isMobile) {
      self.updateListFromMapMarkers();
    }
    self.finishLoading();
    self.renderFeaturedParks();
    if (self.isFirstLoad) {
      self.isFirstLoad = false;
      window.dbs.globalEvents.emit('performInitialExperienceFilter');
    }
  })
  // On clear typeahead results, clear distance and clear query

  self.typeahead.el.find('.clear-button').on('click', (e) => {
    self.filters.query = ''
    self.pushNewState(self.filters);
    self.$resultsContainerEl.find('.result .distance').hide()


  })

  self.$searchStatsCurrentEl = self.$el.find('.search-stats .current')
  self.$searchStatsTotalEl = self.$el.find('.search-stats .total')

  self.$noResultsEl = self.$el.find('.no-results-wrapper');
  self.$noResultsEl.find('#no_results_zoom_out').on('click', (e) => {
    e.preventDefault();
    self.map.setZoom(self.defaultZoomLevel)
    self.map.setCenter(new google.maps.LatLng(self.defaultCenterLocation.lat, self.defaultCenterLocation.lng))
  })
  self.$noResultsEl.find('#no_results_clear_filters').on('click', (e) => {
    e.preventDefault();
    self.clearFilters();
  })
  self.$noResultsEl.hide(); // Hidden by default

  self.updateSearchStats = (currentlyShowing, totalCount) => {
    if (self.isMobile) {
      currentlyShowing = self.$resultsContainerEl.find('.result:visible').length
      self.$noResultsEl.find('.mobile-hide').hide(); // shows the zoom out link
    } else {
      self.$noResultsEl.find('.mobile-hide').show();
    }
    //totalCount = self.markers.length
    if (currentlyShowing == 0) {
      self.$noResultsEl.show();
      self.$resultsContainerEl.hide();
    } else {
      self.$noResultsEl.hide();
      self.$resultsContainerEl.show();
    }

    self.$searchStatsCurrentEl.text(currentlyShowing)
    self.$searchStatsTotalEl.text(totalCount)
  }

  self.filterPropertiesByBrand = function (properties) {
    // NOTE: If it's G'day, we don't need to filter
    let propertyes = [];
    if (self.isDhpTheme) {
      properties = properties.filter((property) => property.brands.includes('Discovery Parks'))
    } else {
      properties = properties.filter((property) => property.brands.includes("G'Day Parks"))
    }
    return properties;
  }

  self.applyFilters = () => {
    self.updateFiltersFromPage()
    self.$el.find('.secondary-button').popup('hide')
  }



  self.pushNewState = (newFilters) => {
    // Handle
    const url = window.location.pathname.replace(/\/+/g, '/')

    //url.pathname = self.isDhpTheme ? '/caravan-parks' : '/parks';
    // Push the new URL to history
    const urlforParams = new URL(window.location.href);
    urlforParams.searchParams.forEach((val, key) => {
      // Add a Property
      if (!newFilters.hasOwnProperty(key)) {
        Object.defineProperty(newFilters, key, { value: self.qs.getParameter(key), writable: true, configurable: true, enumerable: true });
      }
    });
    history.pushState({ filters: newFilters }, $(' head title').html(), url + '?' + $.param(newFilters))
  }

  self.updateFilterButtons = () => {
    if (self.filters.query == '') {
      // These should already be correct, but just in case users are changing screen sizes and have no map
      if (self.isMobile) {
        self.$el.find('#location-typeahead').attr('placeholder', 'Find Destination');
      } else {
        self.$el.find('#location-typeahead').attr('placeholder', 'Map area');
      }
    }
    // This is double counting mobile AND desktop filters, dividing by two at this point works great because we set them all anyway... but there's better ways to do this
    if (self.$el.find('input[name="parkFeatures[]"]:checked').length > 0) {

      // Check if pets is ticked
      let value = 0;
      if ($('input[name="pets[]"]:checked').length > 0) {
        value = self.$el.find('input[name="parkFeatures[]"]:checked').length / 2  // Add an additional number for pets, doesn't matter which is checked
        $('.mobile-pets-counter span').text(1);
        $('.mobile-pets-counter').show()
        $('.mobile-features-counter span').text(value) // Subtract 1 for pets on mobile because it's separate
        if (value >= 1) {
          $('.mobile-features-counter').show();
        }
        $('.park-features-button .counter span').text(value + 1)
      } else {
        // No pets on mobile
        $('.mobile-pets-counter').hide();
        value = self.$el.find('input[name="parkFeatures[]"]:checked').length / 2
        $('.park-features-button .counter span').text(value)
        if (value >= 1) {
          $('.mobile-features-counter span').text(value)
          $('.mobile-features-counter').show();
        }
      }

      $('.park-features-button .counter').show()
      $('.park-features-button').addClass('active')
    } else {
      if ($('input[name="pets[]"]:checked').length > 0) {
        // Dogs but no features are checked
        $('.mobile-pets-counter span').text(1);
        $('.mobile-pets-counter').show()
        $('.park-features-button .counter span').text(1);
        $('.park-features-button .counter').show();
        $('.park-features-button').addClass('active')
      } else {
        $('.mobile-pets-counter').hide();
        $('.mobile-features-counter').hide();
        $('.park-features-button .counter').hide()
        $('.park-features-button').removeClass('active')
      }
    }

    if (self.$el.find('input[name="experiences[]"]:checked').length > 0) {
      let value = self.$el.find('input[name="experiences[]"]:checked').length / 2
      $('.experiences-button .counter span').text(value)
      $('.mobile-experiences-counter span').text(value)
      $('.experiences-button .counter').show()
      $('.mobile-experiences-counter').show();
      $('.experiences-button').addClass('active')
    } else {
      $('.experiences-button .counter').hide()
      $('.mobile-experiences-counter').hide();
      $('.experiences-button').removeClass('active')
    }
    if (self.$el.find('input[name="parkState[]"]:checked').length > 0) {
      let value = self.$el.find('input[name="parkState[]"]:checked').length / 2;
      $('.park-state-button .counter span').text(value)
      $('.mobile-state-counter span ').text(value)
      $('.park-state-button').addClass('active')
      $('.park-state-button .counter').show()
      $('.mobile-state-counter').show();
    } else {
      $('.mobile-state-counter').hide();
      $('.park-state-button').removeClass('active')
      $('.park-state-button .counter').hide()
    }
  }

  self.setFiltersFromUrl = () => {
    // NOTE The 'guest selector' widget handles itself.

    // Check if there's no query strings, if not set to defaults
    if (window.location.search == '') {
      self.filters = self.getDefaultFilters()
      self.pushNewState(self.filters)
    }
    var urlForParam = new URL(window.location.href);
    urlForParam.searchParams.forEach((val, key) => {
      // Add a Property
      if (!self.filters.hasOwnProperty(key)) {
        Object.defineProperty(self.filters, key, { value: self.qs.getParameter(key), writable: true, configurable: true, enumerable: true });
      }
    });

    // Search query and 'currently showing' text
    const query = self.qs.getParameter('query')
    //self.$currentlyShowingEl = self.$el.find('.currently-showing')
    /*
    if (query) {
      self.typeahead.setValue(query)
      self.$el.find('.query.input').val(query)
      self.$currentlyShowingEl.find('.location').html(query)
      self.$currentlyShowingEl.show()
    }
      */

    /*
    const stateText = self.$el.find('input.park-search-state').val()
    const regionText = self.$el.find('input.park-search-region').val()
    const regionStateText = [regionText, stateText].filter(Boolean).join(', ')
    if (!query && regionStateText) {
      self.$currentlyShowingEl.find('.location').html(regionStateText)
      self.$currentlyShowingEl.show()
    }

    if (!query && !regionStateText) {
      self.$currentlyShowingEl.hide()
    }
    */

    // Dates
    const arriveDate = self.qs.getParameter('arrive')
      ? moment(self.qs.getParameter('arrive'), 'YYYY-MM-DD').toDate()
      : self.todayDate
    if (arriveDate < moment(self.todayDate).format('YYYY-MM-DD')) {
      arriveDate = moment(self.todayDate).format('YYYY-MM-DD');
      self.filters.arrive = arriveDate
    }

    self.$el.find('.arrive.input').val(moment(arriveDate).format('YYYY-MM-DD'))
    self.$dateSelectorEl.data('daterangepicker').setStartDate(arriveDate)

    const departDate = self.qs.getParameter('depart')
      ? moment(self.qs.getParameter('depart'), 'YYYY-MM-DD').toDate()
      : self.tomorrowDate
    // Check if it's in the past and set it to tomorrow if that's the case
    if (departDate < moment(self.tomorrowDate).format('YYYY-MM-DD')) {
      departDate = moment(self.tomorrowDate).format('YYYY-MM-DD');
      self.filters.depart = departDate
    }
    self.$el.find('.depart.input').val(moment(departDate).format('YYYY-MM-DD'))
    self.$dateSelectorEl.data('daterangepicker').setEndDate(departDate)

    self.$el
      .find('.date-range-picker')
      .removeClass('empty')
      .text(`${moment(arriveDate).format('DD MMM')} – ${moment(departDate).format('DD MMM')}`)

    // Guests from home page search
    const adults = self.qs.getParameter('adults') ?? 2
    self.$el.find('.adults.input').val(adults)

    const kids = self.qs.getParameter('kids') ?? 0
    self.$el.find('.kids.input').val(kids)

    const infants = self.qs.getParameter('infants') ?? 0
    self.$el.find('.infants.input').val(infants)

    // Filter checkboxes
    self.searchForm.el
      .find('.desktop-filters input[type="checkbox"], .mobile-filters input[type="checkbox"]')
      .prop('checked', false)

    const experiences = self.qs.getParameter('experiences') ? self.qs.getParameter('experiences').split('|') : []
    experiences.map(function (value) {
      let name = 'experiences[]'
      self.searchForm.el.find(`input[name="${name}"][value="${value}"]`).each(function () {
        $(this).parent('.ui.checkbox').checkbox('set checked')
      })
    })

    const features = self.qs.getParameter('features') ? self.qs.getParameter('features').split('|') : []
    features.map(function (value) {
      let name = 'parkFeatures[]'
      self.searchForm.el.find(`input[name="${name}"][value="${value}"]`).each(function () {
        $(this).parent('.ui.checkbox').checkbox('set checked')
      })
    })

    if (self.qs.getParameter('pets') !== null) {
      if (self.qs.getParameter('pets') == 'true' || self.qs.getParameter('pets') == '1') {
        self.searchForm.el.find(`input[name="pets[]"][value="1"]`).each(function () {
          $(this).parent('.ui.checkbox').checkbox('set checked')
        })
      } else {
        // This defaults it to no dogs,
        //self.searchForm.el.find(`input[name="pets[]"][value="0"]`).each(function () {
        //$(this).parent('.ui.checkbox').checkbox('set checked')
        //})
      }
      // Toggle correct
    }

    // Set Map center to lat/lng if present
    // Set zoom level to zoom if present
    if (self.qs.getParameter('lat') !== null && self.qs.getParameter('lng') !== null) {
      self.filters.lat = self.qs.getParameter('lat')
      self.filters.lng = self.qs.getParameter('lng')
    }

    if (self.qs.getParameter('zoom') !== null && parseInt(self.qs.getParameter('zoom')) > 0) {
      self.filters.zoom = parseInt(self.qs.getParameter('zoom'))
    }

    if (self.qs.getParameter('states') !== null && self.qs.getParameter('states') !== '') {
      const states = self.qs.getParameter('states') ? self.qs.getParameter('states').split('|') : [];
      states.map(function (value) {
        let name = 'parkState[]'
        self.searchForm.el.find(`input[name="${name}"][value="${value}"]`).each(function () {
          $(this).parent('.ui.checkbox').checkbox('set checked')
          $(this).attr('checked', 'checked');
        })
      })

    }
    self.updateFilterButtons()
    self.updateViewParkButtons();

  }
  self.updateViewParkButtons = () => {
    const $viewParkButtons = self.$resultsContainerEl.find('.view-park-link')
    $viewParkButtons.each((k, el) => {
      // Create a URL object from the href
      const $el = $(el)
      let currentLink = $el.attr('href');
      if (currentLink.includes('?')) {
        //split and replace
        currentLink = currentLink.split('?')[0];
      }

      $el.attr('href', currentLink + window.location.search)

    });


    // update park links
    //self.finishLoading();
  }

  self.$mapEl = self.$el.find('.widget.park-map-v2')
  self.$mapCanvasEl = self.$mapEl.find('.map-canvas').get(0)
  self.isSearchFromHomePage = false;
  self.initBaseGoogleMap = () => {


    // Check if we're coming from a find parks > state dropdown
    if (self.getStateUrlArray().some(state => window.location.pathname.includes(state))) {
      const state = self.getStateUrlArray().find(state => window.location.pathname.includes(state));
      let customSearchLocation = self.getCustomSearchLocation(state)
      self.filters.lat = customSearchLocation.lat
      self.filters.lng = customSearchLocation.lng
      self.filters.zoom = customSearchLocation.zoom
      var shortState = self.getStateFilterValueFromName(state)
      self.filters.states = shortState;
      self.shouldHandleFirstMapPan = true;
    }
    if (self.qs.getParameter('query') !== null && self.qs.getParameter('query') !== '') {
      self.isSearchFromHomePage = true;
      self.typeahead.setValue(self.qs.getParameter('query'))
      self.filters.query = self.qs.getParameter('query')
      var customSearch = self.getCustomSearchLocation(self.qs.getParameter('query'));
      if (customSearch) {
        self.filters.zoom = customSearch.zoom
        self.filters.lng = customSearch.lng
        self.filters.lat = customSearch.lat
      }
    }
    // initialize the map
    let center = new google.maps.LatLng(self.filters.lat, self.filters.lng)

    // If we're using the default lat/lng, we dont' want to use the zoom level we've got in filters because it ends up in the middle of nowhere
    let zoom = self.filters.zoom ? parseInt(self.filters.zoom) : self.defaultZoomLevel
    // Track map load for optimization stats
    self.optimizer.trackMapLoad();
    
    self.map = new google.maps.Map(self.$mapCanvasEl, {
      center: center,
      zoom: zoom,
      maxZoom: 18,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT,
      },
      restriction: {
        strictBounds: false,
        latLngBounds: self.australiaBounds,
      },
      //mapTypeId: google.maps.MapTypeId.HYBRID,
      mapId: '5c8f7cd9520dccd0', // TODO: Move this from my dhpjacob@gmail.com to a central account
    })

    self.$mapEl.attr('style', 'opacity:1')


  }



  self.populateInitialMap = () => {
    // Check if we're on any specific page and set filters if that's the case, e.g. /parks/newsouthwales

    self.initBaseGoogleMap()

    self.repopulateParkMapCache()



  }



  self.createCustomMarkerElement = (property) => {
    const markerElement = document.createElement('div')
    markerElement.className = 'marker '
    markerElement.setAttribute('data-property-code', property.code)
    markerElement.innerHTML = self.markerTemplate({
      propertyCode: property.code,
      state: property.state.toLowerCase(),
      hasPrice: property.pricing.totalCabinPrice > 0 || property.pricing.totalSitePrice > 0,
      TotalCabinPrice: self.roundPricing(property.pricing.totalCabinPrice),
      TotalSitePrice: self.roundPricing(property.pricing.totalSitePrice),
    })

    return markerElement
  }

  self.createCustomClusterer = (label) => {
    const markerElement = document.createElement('div')
    markerElement.className = 'cluster-marker '
    markerElement.innerHTML = `<span>${label}</span>`

    return markerElement
  }
  self.changeImageCropParameters = (imageUrl, minWidth = 500, minHeight = 280) => {
    const urlObject = new URL(imageUrl);

    // Get current dimensions
    let currentWidth = parseInt(urlObject.searchParams.get('width')) || 0;
    let currentHeight = parseInt(urlObject.searchParams.get('height')) || 0;

    // If dimensions are not in the URL, return the original URL
    if (currentWidth === 0 || currentHeight === 0) {
      // TODO, add width/height to it
      urlObject.searchParams.set('width', minWidth);
      urlObject.searchParams.set('height', minHeight);
      return urlObject.toString();
    }

    // Calculate aspect ratio
    const aspectRatio = currentWidth / currentHeight;

    // Calculate new dimensions
    let newWidth = currentWidth;
    let newHeight = currentHeight;

    // Adjust width if it's below minimum
    if (newWidth > minWidth) {
      newWidth = minWidth;
      newHeight = Math.round(newWidth / aspectRatio);
    }

    // Adjust height if it's still below minimum
    if (newHeight > minHeight) {
      newHeight = minHeight;
      newWidth = Math.round(newHeight * aspectRatio);
    }

    // Update URL parameters
    urlObject.searchParams.set('width', newWidth);
    urlObject.searchParams.set('height', newHeight);

    return urlObject.toString();

  }

  self.$resultsContainerEl = self.$el.find('.results-container')

  // Helper function to check if a park allows dogs
  self.checkDogFriendly = (parkCode) => {
    return window.dogAllowed && window.dogAllowed.includes(parkCode);
  }

  // Helper function to check if a park has a pool
  self.checkHasPool = (parkCode, parkName) => {
    // Check if there's a pool feature in the feature mapping
    if (window.featureMapping) {
      // Look for common pool-related feature keys
      const poolFeatures = ['Swimming Pool', 'pool', 'swimming', 'Pool', 'Swimming', 'swim', 'Swim', 'pools', 'Pools'];
      for (let feature of poolFeatures) {
        if (window.featureMapping[feature] && window.featureMapping[feature].includes(parkCode)) {
          
          return true;
        }
      }
    }
    return false;
  }

  self.createParkTiles = () => {
    const resultsFragment = new DocumentFragment()
    const filteredBrandProperties = self.filterPropertiesByBrand(self.populateMap_properties)
    console.log(filteredBrandProperties)
    filteredBrandProperties.forEach(function (p) {
      // console.log(p)
      const template = document.createElement('template')
      const imageUrls = p.images.map((image) => self.changeImageCropParameters(image.url))

      const pricingDetails = self.parkTileDetailsTemplate({
        Prices: {
          Message: p.pricing.message,
          TotalCabinPrice: self.roundPricing(p.pricing.totalCabinPrice),
          TotalSitePrice: self.roundPricing(p.pricing.totalSitePrice),
          Guests: $('.total.guests.input').val(),
          GuestsLabel: 'Guests',
          Nights: 2, // TODO Calculate this
          NightsLabel: 'Nights',
        },
      })

      //let distance = (self.qs.getParameter('query') !== null && self.qs.getParameter('query') != '') ? `${p.distanceKm}km from ${self.qs.getParameter('query')}` : false
      let distance = false;
      let parkName = p.name;
      if (p.brands.includes('Discovery Parks') && !self.isDhpTheme) {
        if (!p.name.includes("Resort") && !p.name.includes("Discovery Parks")) {
          parkName = "Discovery Parks - " + p.name;
        }
      }
      else if (p.brands.includes('Discovery Parks') && self.isDhpTheme) {
        if (!p.name.includes("Resort") && !p.name.includes("Discovery Parks")) {
          parkName = "Discovery Parks - " + p.name;
        }
      }
      template.innerHTML = self.parkTileTemplate({
        PropertyCode: p.code,
        ImageUrls: imageUrls,
        PropertyUrl: '/parks/permalink/' + p.code + window.location.search,
        PropertyName: parkName,
        State: p.state,
        StateLower: p.state.toLowerCase(),
        Town: p.area,
        Distance: distance,
        OriginalPropertyName: p.name,
        //Restrictions: [{
        //HoverText: '',
        //DisplayName: '',
        //ImageUrl: ''
        //}],
        Description: '',
        DisplayRating: Boolean(p.reviews),
        OverallRating: p.reviews?.overallRating || '',
        ReviewCount: p.reviews?.reviewCount || '',
        PricingDetails: pricingDetails,
        HasDogFriendly: self.checkDogFriendly(p.code),
        HasPool: self.checkHasPool(p.code, parkName),
      })

      resultsFragment.append(template.content)
    })

    self.$resultsContainerEl.append(resultsFragment).show()
    self.updateViewParkButtons();
  }

  self.updateParkTiles = (propertyList) => {
    self.$resultsContainerEl.hide();
    // Pick them and re-order them from the top
    propertyList.forEach(code => {
      const $elem = self.$resultsContainerEl.find(`.result[data-property-code="${code}"]`)
      if ($elem.length > 1) {
        if (self.isGeoLocationSearch) {
          $elem.find('.distance').show();
        }
        self.$resultsContainerEl.append();

      }
    });

    self.$resultsContainerEl.find('.result').each((k, elem) => {
      const $elem = $(elem);
      if (propertyList.includes($elem.attr('data-property-code'))) {
        $elem.show()
      } else {
        $elem.hide();
      }
    });
    if (self.isGeoLocationSearch) {
      window.setTimeout(function () {
        self.$resultsContainerEl.find('.distance').show();
      }, 250);
    }

    self.$resultsContainerEl.show();
  }

  self.initParkTilesImageSlider = () => {
    self.$resultsContainerEl.find('.result .images').each(function (i, el) {
      const $resultItemImagesEl = $(el)
      if ($resultItemImagesEl.attr('data-images-count') > 1) {
        const swiperEl = $resultItemImagesEl.find('.swiper')
        swiperEl.addClass('as-slider')
        dom.i2svg({ node: el }) // render slider navigation arrows
        new Swiper(swiperEl, {
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: $resultItemImagesEl.find('.swiper-button-next'),
            prevEl: $resultItemImagesEl.find('.swiper-button-prev'),
          },
          pagination: {
            el: $resultItemImagesEl.find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
    })
  }

  self.allMarkers = [];
  self.createBaseMapPins = () => {
    // clear bounds
    self.bounds = new google.maps.LatLngBounds()

    // add markers to map
    const filteredBrandProperties = self.filterPropertiesByBrand(self.populateMap_properties)
    self.populateMap_properties = filteredBrandProperties;
    let markers = filteredBrandProperties.map((property) => {
      const propertyCode = property?.code

      if (propertyCode && property.location.lat !== '' && property.location.lng !== '') {

        // Custom markers aren't working for some reason
        let position = new google.maps.LatLng(property.location.lat, property.location.lng)
        let content = self.createCustomMarkerElement(property)
        let marker = new AdvancedMarkerElement({
          content,
          position,
          map: self.map,
          gmpClickable: true,
        })
        marker.isHidden = false; // By default show every marker

        marker.addListener('click', (e) => {
          self.handleMarkerClick(e, marker)
        })
        self.markers.push(marker)

        self.customMarkers[propertyCode] = new CustomMarker({
          position,
          map: self.map,
          data: property,
          isHidden: false,
        })

        return marker
      } else {
        console.warn(`Not able to place marker for ${property.code}`)
      }
    })
    self.allMarkers = markers;
    // console.log('self.markers', self.markers)
    // console.log('self.customMarkers', self.customMarkers)

    // Marker count
    self.markerCluster = new MarkerClusterer({
      map: self.map,
      markers: self.markers.filter(m => !m.isHidden),

      renderer: {
        render: ({ count, position }) => {
          return new google.maps.marker.AdvancedMarkerElement({
            position,
            content: self.createCustomClusterer(count.toString()),
          })
        },
      },

    })


    self.markerCluster.addListener('click', (cluster) => {
      const clusteredMarkers = cluster.markers
      const bounds = new google.maps.LatLngBounds()

      for (let marker of clusteredMarkers) {
        bounds.extend(marker.position)
      }

      self.map.fitBounds(bounds)
      self.updatePricingPostFilter();
      //self.performSearch(true); // After zooming in, re-search because pricing might be incorrect
    })

  }

  // NOTE InfoBox (plugin) does not work with AdvancedMarkerElement markers.
  self.infobox = new InfoBox({
    alignBottom: true,
    closeBoxMargin: '0px 0px 0px 0px',
    closeBoxURL: self.$mapEl.attr('data-close-image'),
    disableAutoPan: false,
    enableEventPropagation: true,
    infoBoxClearance: 0,
    isHidden: false,
    maxWidth: 200,
    pane: 'floatPane',
    pixelOffset: new google.maps.Size(-100, -40),
    zIndex: 1,
  })

  // self.infowindow = new google.maps.InfoWindow({
  //   pixelOffset: new google.maps.Size(-100, -40),
  // })

  self.handleMarkerClick = (e, marker) => {
    //console.log('handleMarkerClick', e)
    //console.log('handleMarkerClick2', marker)
    // Remove 'active' styles from all markers
    let markerEls = self.$mapCanvasEl.querySelectorAll('.marker')
    markerEls.forEach((el) => el.classList.remove('active'))

    // Set 'active' styles on clicked marker
    const markerEl = e.domEvent.currentTarget.querySelector('.marker')
    const propertyCode = markerEl.getAttribute('data-property-code')
    markerEl.classList.add('active')

    // Render clicked markers' popup contents
    const customMarker = this.customMarkers[propertyCode]
    customMarker.data.url = customMarker.data.code + window.location.search
    // Update View Park URL based with search params
    // console.log('customMarker', customMarker)
    self.infobox.setContent(self.infoboxTemplate(customMarker.data))
    self.infobox.open(self.map, customMarker)

    // self.infowindow.close()
    // self.infowindow.setContent(self.infoboxTemplate(data))
    // self.infowindow.open(marker.map, marker)

    // NOTE `setTimeout` used to ensure infobox and contents is accessible in DOM after opening.
    setTimeout(function () {
      // handle markers popup images
      const infoboxImages = $('#infobox-images')
      if (infoboxImages.attr('data-images-count') > 1) {
        const swiperEl = infoboxImages.find('.swiper')
        swiperEl.addClass('as-slider')
        new Swiper(swiperEl, {
          loop: true,
          spaceBetween: 0,
          pagination: {
            el: infoboxImages.find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
    }, 0)
  }

  // Set item with expiry, default TTL is 30 minutes (0.5 hours)
  function localStorageSetWithExpiry(key, value, ttl = .5 * 60 * 60 * 1000) {
    const now = new Date()
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  // Get item and check expiry
  function localStorageGetWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }
  self.quickHash = (key) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(key);
    const hashBuffer = crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  self.API_BaseURL = window.ParkSearch_BaseAPIUrl
  //self.API_BaseURL = "https://preprod-exp-api.gdaygroup.com.au"
  self.API_SearchEndpoint = '/api/v1/parks/searchV3'
  self.API_HeaderCaller = self.isDhpTheme ? 'DhpWeb' : 'GdayWeb'
  self.currentBrand = self.isDhpTheme ? 'Discovery Parks' : "G'Day Parks"
  self.repopulateParkMapCache = () => {
    // We start this cache with a default API call
    $.ajax({
      url: self.API_BaseURL + self.API_SearchEndpoint,
      type: 'GET',
      data: self.mapDefaultAPICall(),
      headers: {
        'Gday-Caller': self.API_HeaderCaller,
      },
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (response) {
        for (let i = 0; i < response.result.length; i++) {
          if (!window.parkCodeList.includes(response.result[i].code) && response.result[i].brands.includes(self.currentBrand)) {
            console.log("Adding " + response.result[i].code + " to park list");
            window.parkCodeList.push(response.result[i].code);
          }
        }
        if (self.populateMap_totalCount === false) {
          self.populateMap_totalCount = response.totalCount
        }
        self.populateMap_properties = self.populateMap_properties.concat(response.result)
        window.populateMap_properties = self.populateMap_properties
        self.populateMap_currentOffset += response.result.length
        // Remove this for prod (probably)

        // Go through each park and set the pin up on the map here
        if (self.populateMap_currentOffset < self.populateMap_totalCount) {
          // Recurse lol nothing could go wrong here (it hasn't yet!)
          //console.log('recursing into another populateInitialMap call')
          self.repopulateParkMapCache()
        } else {
          // Have loaded all properties
          // Reset offset for next call, as we're done with this round
          self.populateMap_currentOffset = 0
          //console.log('Loaded all properties, caching for 24h')
          // Not caching for now
          //localStorageSetWithExpiry(self.populateMap_localStorageKey+self.quickHash(JSON.stringify(self.mapFiltersToAPICall())), JSON.stringify(self.populateMap_properties))
          window.dbs.globalEvents.emit(self.populateMap_event_key, self.populateMap_properties, true)
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        //debugger // TODO Handle bad error state,
      })
  }

  self.updateFiltersFromPage = () => {
    // Retrieve filters from page and update self.filters
    let features = []
    self.$el.find('input[name="parkFeatures[]"]:checked').each(function (k, elem) {
      let feature = $(elem).val()
      if (!features.includes(feature)) {
        features.push(feature)
      }
    })
    const featuresString = features.join('|').toString()

    let experiences = []
    self.$el.find('input[name="experiences[]"]:checked').each(function (k, elem) {
      let experience = $(elem).val()
      if (!experiences.includes(experience)) {
        experiences.push(experience)
      }
    })
    const experiencesString = experiences.join('|').toString()
    let states = [];
    let statesString = '';
    self.$el.find('input[name="parkState[]"]:checked').each(function (k, elem) {
      let state = $(elem).val()
      if (!states.includes(state)) {
        states.push(state)
      }
    })

    if (states.length >= 1) {
      if (states.length >= 2) {
        statesString = states.join('|').toString()
      } else {
        statesString = states[0];
      }
    }
    if (statesString != "" && self.filtersBeingApplied) {
      self.map.setZoom(self.defaultZoomLevel);
      self.map.setCenter(new google.maps.LatLng(self.defaultCenterLocation.lat, self.defaultCenterLocation.lng));
      // do zoom here?
    }
    let pets = self.$el.find('input[name="pets[]"]:checked').length === 0
      ? ''
      : self.$el.find('input[name="pets[]"]:checked').val() === '1'
    const newFilters = {
      arrive: self.$el.find('.arrive.input').val(),
      depart: self.$el.find('.depart.input').val(),
      adults: self.$el.find('.guest-selector .adults.input').val(),
      kids: self.$el.find('.guest-selector .kids.input').val(),
      infants: self.$el.find('.guest-selector .infants.input').val(),
      experiences: experiencesString,
      features: featuresString,
      // pets default to '', or true/false for 'allowed'/'not allowed'
      pets: pets,
      query: self.typeahead.getValue(),
      states: statesString,
      lat: self.filters.lat,// these get updated elsewhere
      lng: self.filters.lng,// these get updated elsewhere
    }
    // console.log('newFilters', newFilters)
    self.filters = newFilters
  }

  self.getMapCenterLatLng = () => {
    const center = self.map.getCenter()
    const lat = center.lat()
    const lng = center.lng()

    return { lat, lng }
  }

  self.mapDefaultAPICall = () => {
    return {
      checkIn: '', // Default to Today
      checkOut: '', // Default to Tomorrow
      numberOfAdults: 2,
      lat: '',
      lng: '',
      numberOfInfants: 0,
      numberofKids: 0,
      states: [],
      experiences: [],
      features: [],
      pageSize: 10000,
      offset: 0,
      query: 0,
    }
  }
  //asdf
  self.mapFiltersToAPICall = () => {
    // Maps URL data to API call i.e. transforms "arrive" to "checkin"
    // Hard coded defaults

    const newData = {
      checkIn: self.filters.arrive, // Default to Today
      checkOut: self.filters.depart, // Default to Tomorrow
      numberOfAdults: self.filters.adults,
      lat: self.filters.lat,
      lng: self.filters.lng,
      numberOfInfants: self.filters.infants,
      numberofKids: self.filters.kids,
      states: [],
      experiences: [],
      features: [],
      pageSize: self.defaultPageSize,
      offset: self.populateMap_currentOffset,
      query: self.typeahead.getValue(),
    }
    // Quick santity check
    if (newData.checkIn == newData.checkOut) {
      newData.checkOut = moment(newData.checkIn).add(1, 'days').format('YYYY-MM-DD')
    }
    return newData
  }

  self.getFilteredParkCodes = () => {
    let combinedFilteredParkList = [];
    if (self.filters.features == "" && self.filters.experiences == "" && self.filters.states == "") {
      combinedFilteredParkList = window.parkCodeList;
    } else {

      let filteredStateParks = [];
      if (self.filters.states != "") {
        if (self.filters.states.includes('|')) {
          let states = self.filters.states.split('|');
          states.forEach((state) => {
            self.$resultsContainerEl.find('.result[data-property-state="' + state + '"]').each(function (k, elem) {
              filteredStateParks.push($(elem).attr('data-property-code'));
            });
          })


        } else {
          self.$resultsContainerEl.find('.result[data-property-state="' + self.filters.states + '"]').each(function (k, elem) {
            filteredStateParks.push($(elem).attr('data-property-code'));
          });
        }
        // Retrieve property codes
      }
      let filteredFeatureParks = [];
      let filteredExperienceParks = [];
      if (self.filters.features != "") {
        if (self.filters.features.includes("|")) {
          let features = self.filters.features.split("|");
          filteredFeatureParks = window.featureMapping[features[0]]; // Set up initial list so we can start filtering them down
          features.forEach(function (feature) {
            filteredFeatureParks = filteredFeatureParks.filter(value => window.featureMapping[feature].includes(value));
          });
        } else {
          filteredFeatureParks = window.featureMapping[self.filters.features];
        }
      }

      if (self.filters.experiences != "") {
        if (self.filters.experiences.includes("|")) {
          let experiences = self.filters.experiences.split("|");
          filteredExperienceParks = window.experienceMapping[experiences[0]]; // Set up initial list so we can start filtering them down
          experiences.forEach(function (experience) {
            filteredExperienceParks = filteredExperienceParks.filter(value => window.experienceMapping[experience].includes(value));
          });
        } else {
          filteredExperienceParks = window.experienceMapping[self.filters.experiences];
        }
      }
      // Combine the two lists, picking only parks that appear in both

      if (self.filters.features != "" || self.filters.experiences != "" || self.filters.states != "") {
        combinedFilteredParkList = self.commonElements(filteredExperienceParks, filteredFeatureParks, filteredStateParks);
      }
      //
    }
    // Strip out duplicates
    let filteredParkList = [...new Set(combinedFilteredParkList)];
    // Check if dog checkboxes have been checked
    if (self.searchForm.el.find(`input[name="pets[]"]:checked`).length >= 1) {
      // Filter parks by dogs allowed or not allowed
      if (self.searchForm.el.find(`input[name="pets[]"]:checked`).val() == 1) {
        // 1 is allowed
        // First filter out the parks that are not allowed
        filteredParkList = filteredParkList.filter(item => window.dogAllowed.includes(item))
      } else {
        // 0 is not
        //asdf
        filteredParkList = filteredParkList.filter(item => window.dogNotAllowed.includes(item))
      }
      // subtract the opposite parks from the current list
    }
    return filteredParkList;
  }

  self.performSearch = (performAPICall = false) => {
    self.showLoading();
    // First perform the filtering we can locally for experiences/features/dogs
    let filteredParkList = self.getFilteredParkCodes();

    if (performAPICall) {
      // perform API call and then filter visible parks based on the new input from there
      self.updatePricingPostFilter(true);
      self.filterVisibleParkList(filteredParkList)
    } else {
      // have probably just panned the map and not changed booking context, so just filter the visible parks
      self.filterVisibleParkList(filteredParkList)
    }

    if (self.isMobile) {
      self.$resultsContainerEl.find('.result').each((k, elem) => {
        let $elem = $(elem)
        if (filteredParkList.includes($elem.attr('data-property-code'))) {
          $elem.show();
        } else {
          $elem.hide();
        }
      })

    }
    self.updateViewParkButtons();
  }

  self.roundPricing = (price) => {
    return Math.floor(price);

  }
  self.commonElements = (...lists) => {
    // Filter out empty arrays
    const nonEmptyLists = lists.filter(list => list.length > 0);

    // If all lists were empty, return an empty array
    if (nonEmptyLists.length === 0) {
      return [];
    }

    // Find the intersection of all non-empty lists
    return nonEmptyLists.reduce((common, list) =>
      common.filter(item => list.includes(item))
    );
  }

  self.maxMobileDistance = 500;
  self.handlePricingPostFilterResponse = (response, filteredParkList, APIPayload, updateParkTiles) => {

    // try to use as little DOM heavy find() calls as possible here
    let $results = self.$el.find('.results-container .result')
    let $pins = self.$el.find('.map-canvas .marker .pin')

    if ($pins.length == 0) {
      // TODO Possibly use this to avoid doing pin DOM lookups when we know they aren't available
      //debugger;
    }
    if (!response.hasOwnProperty('result')) {
      //debugger;
      console.error('No result from API, something went wrong');

      // Something went wrong - possibly handle it here
    }

    for (let i = 0; i < response.result.length; i++) {
      // Check if the featured park needs to be updated as well
      if (!window.parkCodeList.includes(response.result[i].code && response.result[i].brands.includes(self.currentBrand))) {
        console.log("Adding " + response.result[i].code + " to park list");
        window.parkCodeList.push(response.result[i].code);
      }
      let currentProperty = response.result[i]


      // Check we have pricing to actually update
      let $propertyListItem = $results.filter(`[data-property-code="${currentProperty.code}"]`)
      let $propertyMarker = $pins.filter(`[data-property-code="${currentProperty.code}"]`)


      if (currentProperty.pricing.totalSitePrice > 0 || currentProperty.pricing.totalCabinPrice > 0) {
        // aim here is to
        if ($propertyMarker.length > 0) {
          // marker isn't in a cluster, update prices
          let $markerPriceItems = $propertyMarker.find('.priceset') // there's 2 of these, usually cabins
          let $markerCabinPrice = $markerPriceItems.first().hasClass('cabins') ? $markerPriceItems.first() : $markerPriceItems.last();
          let $markerSitePrice = $markerPriceItems.last().hasClass('sites') ? $markerPriceItems.last() : $markerPriceItems.first();
          let $markerPinDesign = $propertyMarker.find('.pin-design');
          let pricingShownOnMarker = !$markerPinDesign.is(':visible');
          // pricing shown, but no prices,
          if (pricingShownOnMarker && currentProperty.pricing.totalSitePrice == 0 && currentProperty.pricing.totalCabinPrice == 0) {
            // Hide pricing and show empty pin design
            $markerSitePrice.hide();
            $markerCabinPrice.hide();
            $markerPinDesign.show();
          }

          if (currentProperty.pricing.totalSitePrice > 0) {
            // update site price, it should be first (but confirm) to avoid dom search
            $markerSitePrice.find('.price > span').text(self.roundPricing(currentProperty.pricing.totalSitePrice))
            $markerSitePrice.show();
            $markerPinDesign.hide();// have a price, hide it
          } else {
            $markerSitePrice.hide();
          }
          if (currentProperty.pricing.totalCabinPrice > 0) {
            $markerCabinPrice.find('.price > span').text(self.roundPricing(currentProperty.pricing.totalCabinPrice))
            $markerCabinPrice.show();
            $markerPinDesign.hide();// have a price, hide it
          } else {
            $markerCabinPrice.hide();
          }

          // CHeck if
        }

        const $listItemPrices = $propertyListItem.find('.bottom .price-box') // there's 2 .price-box one for cabins one for sites
        const $listItemSitePrice = $listItemPrices.last().hasClass('sites') ? $listItemPrices.last() : $listItemPrices.first()
        const $listItemCabinPrice = $listItemPrices.first().hasClass('cabins') ? $listItemPrices.first() : $listItemPrices.last()
        const $noResults = $propertyListItem.find('.no-results')
        if ($noResults.is(':visible')) {
          $noResults.hide();
        }


        if (currentProperty.pricing.totalSitePrice > 0) {
          // update site price, it should be first (but confirm) to avoid dom search
          $listItemSitePrice.find('.value').text(self.roundPricing(currentProperty.pricing.totalSitePrice))
          $listItemSitePrice.show();
        } else {
          $listItemSitePrice.hide();
        }
        if (currentProperty.pricing.totalCabinPrice > 0) {
          $listItemCabinPrice.find('.value').text(self.roundPricing(currentProperty.pricing.totalCabinPrice))
          $listItemCabinPrice.show();
        } else {
          $listItemCabinPrice.hide();
        }
      } else {
        // No prices at all, hide them and check for message
        $propertyListItem.find('.bottom .price-box').hide();

        if (currentProperty.pricing.message != "") {
          $propertyListItem.find('.pricing-message').text(currentProperty.pricing.message);
        }
        if (currentProperty.pricing.totalSitePrice == 0 && currentProperty.pricing.totalCabinPrice == 0) {
          $propertyListItem.find('.no-results').show();

        }
      }
      if (!filteredParkList.includes(currentProperty.code)) {

        $propertyListItem.hide();
        $propertyMarker.hide(); // this probably won't exist yet :/
      } else {
        $propertyListItem.show();
        $propertyMarker.show(); // this probably won't exist yet :/
      }

      // Update distance only if it's a geolocation search
      if (self.isGeoLocationSearch) {
        let $distance = $propertyListItem.find('.distance');
        $distance.find('.value').text(currentProperty.distanceKm + 'km away');
        $distance.show();
      } else {
        $propertyListItem.find('.distance').hide();
      }


      if (window.featuredParks.includes(currentProperty.code)) {
        // Update featured park pricing
        const $featuredParkTile = self.$noResultsEl.find('.result[data-property-code="' + currentProperty.code + '"]');
        if (currentProperty.pricing.totalSitePrice > 0 || currentProperty.pricing.totalCabinPrice > 0) {
          const $featuredListItemPrices = $featuredParkTile.find('.bottom .price-box') // there's 2 .price-box one for cabins one for sites
          const $featuredListItemSitePrice = $featuredListItemPrices.last().hasClass('sites') ? $featuredListItemPrices.last() : $featuredListItemPrices.first()
          const $featuredListItemCabinPrice = $featuredListItemPrices.first().hasClass('cabins') ? $featuredListItemPrices.first() : $featuredListItemPrices.last()
          const $noResults = $featuredParkTile.find('.no-results')
          if ($noResults.is(':visible')) {
            $noResults.hide();
          }


          if (currentProperty.pricing.totalSitePrice > 0) {
            // update site price, it should be first (but confirm) to avoid dom search
            $featuredListItemSitePrice.find('.value').text(self.roundPricing(currentProperty.pricing.totalSitePrice))
            $featuredListItemSitePrice.show();
          } else {
            $featuredListItemSitePrice.hide();
          }
          if (currentProperty.pricing.totalCabinPrice > 0) {
            $featuredListItemCabinPrice.find('.value').text(self.roundPricing(currentProperty.pricing.totalCabinPrice))
            $featuredListItemCabinPrice.show();
          } else {
            $featuredListItemCabinPrice.hide();
          }
        } else {
          // No prices at all, hide them and check for message
          $featuredParkTile.find('.bottom .price-box').hide();
          if (currentProperty.pricing.message != "") {
            $featuredParkTile.find('.pricing-message').text(currentProperty.pricing.message);
          }
        }
      }
    }

    if (self.isMobile) {
      var orderedByDistance = response.result.sort((a, b) => a.distanceKm - b.distanceKm)
      //orderedByDistance = response.result.filter((property) => property.distanceKm <= self.maxMobileDistance)
      var finalList = orderedByDistance.map(p => p.code)
      for (let i = 0; i < finalList.length; i++) {
        self.$resultsContainerEl.find('[data-property-code="' + finalList[i] + '"]').appendTo(self.$resultsContainerEl);
      }
      // Update search stats for mobile
      //self.filterVisibleParkList(finalList)

    }
    if (self.isSearchFromHomePage) {
      self.isSearchFromHomePage = false;
      var orderedByDistance = response.result.sort((a, b) => a.distanceKm - b.distanceKm)
      var finalList = orderedByDistance.map(p => p.code)
      finalList = finalList.filter(x => filteredParkList.includes(x))
      self.updateParkTiles(finalList);
      self.filterVisibleParkList(finalList)
      for (let i = 0; i < finalList.length; i++) {
        self.$resultsContainerEl.find('[data-property-code="' + finalList[i] + '"]').appendTo(self.$resultsContainerEl);
      }
    }
    if (updateParkTiles && !self.isMobile) { // Don't need to run this on mobile as there's no map
      var orderedByDistance = response.result.sort((a, b) => a.distanceKm - b.distanceKm)
      var finalList = orderedByDistance.map(p => p.code)
      finalList = finalList.filter(x => filteredParkList.includes(x))
      self.updateParkTiles(finalList);
      self.filterVisibleParkList(finalList)
      for (let i = 0; i < finalList.length; i++) {
        self.$resultsContainerEl.find('[data-property-code="' + finalList[i] + '"]').appendTo(self.$resultsContainerEl);
      }
    }
    if (self.isGeoLocationSearch) {
      self.$resultsContainerEl.find('.distance').show();
    } else {
      self.$resultsContainerEl.find('.distance').hide();
    }

    self.updateListFromMapMarkers();

  }
  self.updateParkTileDistanceAndOrder = () => {

    let APIPayload = self.mapFiltersToAPICall()
    let filteredParkList = self.getFilteredParkCodes();
    $('.results-container .result').hide();
    self.showLoading();
    // Perform price update, we should have the new markers from the filtering done above
    $.ajax({
      url: self.API_BaseURL + self.API_SearchEndpoint,
      type: 'GET',
      data: APIPayload,
      headers: {
        'Gday-Caller': self.API_HeaderCaller,
      },
      dataType: 'json',
      contentType: 'application/json',
      success: function (response) {

        if (self.isMobile) {

          var orderedByDistance = response.result.sort((a, b) => a.distanceKm - b.distanceKm)
          //orderedByDistance = response.result.filter((property) => property.distanceKm <= self.maxMobileDistance)
          var finalList = orderedByDistance.map(p => p.code)
          for (let i = 0; i < finalList.length; i++) {
            self.$resultsContainerEl.find('[data-property-code="' + finalList[i] + '"]').appendTo(self.$resultsContainerEl);
          }
          // update distances
          // Update distance
          if (self.isGeoLocationSearch) {
            for (let i = 0; i < response.result.length; i++) {
              let currentProperty = response.result[i]
              let $propertyListItem = self.$resultsContainerEl.find('.result[data-property-code="' + currentProperty.code + '"]')
              let $distance = $propertyListItem.find('.distance');
              $distance.find('.value').text(currentProperty.distanceKm + 'km');
              $distance.show();
            }
          }
        } else {
          // Just handle the whole thing for desktop
          self.handlePricingPostFilterResponse(response, filteredParkList, APIPayload, true)
        }
      },
      complete: function () {
        $('.results-container .result').show();
        self.finishLoading();
      }
    })

  }

  self.updatePricingPostFilter = (updateParkTiles = false) => {
    self.showLoading();
    let APIPayload = self.mapFiltersToAPICall()

    let filteredParkList = self.getFilteredParkCodes();
    // Perform price update, we should have the new markers from the filtering done above
    $.ajax({
      url: self.API_BaseURL + self.API_SearchEndpoint,
      type: 'GET',
      data: APIPayload,
      headers: {
        'Gday-Caller': self.API_HeaderCaller,
      },
      dataType: 'json',
      contentType: 'application/json',
      success: function (response) {
        self.handlePricingPostFilterResponse(response, filteredParkList, APIPayload, updateParkTiles)
      },
      complete: function () {
        self.finishLoading();
      }
    })
  }

  // TODO
  self.isMobile = $(window).width() <= 1023;

  window.filteredParkCodes = [];
  self.filterVisibleParkList = (propertyCodeList) => {
    // Mobile
    window.filteredParkCodes = propertyCodeList;

    if (propertyCodeList.length == 0) {
      self.markers.forEach((marker) => {
        marker.isHidden = false;
        marker.targetElement.children[0].children[0].style.display = ''
      });
    }
    let newMarkers = [];
    self.allMarkers.forEach((marker) => {
      let markerPropertyCode = marker.targetElement.children[0].children[0].attributes['data-property-code'].value
      if (propertyCodeList.includes(markerPropertyCode)) {
        newMarkers.push(marker);
      } else {
        //marker.isHidden = true;
        //marker.targetElement.children[0].children[0].style.display = 'none'
      }
    })
    self.markers = newMarkers;
    if (self.markerCluster) {
      self.markerCluster.setMap(null); // Kill old clusters, recreate them again so they refresh counts and such
    }
    self.markerCluster = new MarkerClusterer({
      map: self.map,
      markers: self.markers,

      renderer: {
        render: ({ count, position }) => {
          return new google.maps.marker.AdvancedMarkerElement({
            position,
            content: self.createCustomClusterer(count.toString()),
          })
        },
      },

    })

    self.markerCluster.addListener('click', (cluster) => {
      const clusteredMarkers = cluster.markers
      const bounds = new google.maps.LatLngBounds()

      for (let marker of clusteredMarkers) {
        bounds.extend(marker.position)
      }

      self.map.fitBounds(bounds)
      window.setTimeout(function () {
        self.updatePricingPostFilter();
      }, 250);
    })
    // Update left side.
    if (self.isMobile) {
      //$('.results-container .result').show();
    } else {
      $('.results-container').hide()
      $('.results-container .result').each((k, elem) => {
        if (propertyCodeList.includes($(elem).attr('data-property-code'))) {
          $(elem).show()
        } else {
          $(elem).hide()
        }
      });
    }
    $('.results-container').show()

    let visibleMarkers = self.getVisibleMarkers(self.map, self.markers)

    self.updateSearchStats(visibleMarkers.length, self.populateMap_properties.length)
    self.updatePricingPostFilter();

  }

  self.triggerResearch = (pushState = true, performAPICall = false) => {
    self.updateFiltersFromPage() // Updates self.filters

    if (pushState) {
      self.pushNewState(self.filters) // updates URL based on self.filters (if needed)
    }

    self.performSearch(performAPICall) // searches based on new self.filters
  }
  self.clearFilters = () => {

    self.$el.find('.pets-toggle').removeClass('active')
    self.$el.find('input[type="checkbox"]').prop('checked', false)

    self.$dateSelectorEl.data('daterangepicker').setStartDate(self.todayDate)
    self.$dateSelectorEl.data('daterangepicker').setEndDate(self.tomorrowDate)

    self.$el
      .find('.date-range-picker')
      .addClass('empty')
      .text(`${moment(self.todayDate).format('DD MMM')} – ${moment(self.tomorrowDate).format('DD MMM')}`)
    self.$el.find('.arrive.input').val(moment(self.todayDate).format('YYYY-MM-DD'))
    self.$el.find('.depart.input').val(moment(self.tomorrowDate).format('YYYY-MM-DD'))

    self.applyFilters()

    if (self.$mobileFiltersEl.is(':visible')) {
      self.$mobileFiltersEl.toggle()
    }
    self.updateFilterButtons()
    self.triggerResearch(true, false) // Applying just filters doesn't require an API call
  }
  self.$el.find('.clear-filters-button').click(function (e) {
    e.preventDefault()
    self.clearFilters();

  })


  self.isFirstMapPan = true;
  self.shouldHandleFirstMapPan = false;
  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ParkSearch init', self)
    }


    // If there's search input in the query string, put it in the search box and set filters
    if (self.qs.getParameter('query') !== null && self.qs.getParameter('query') !== '') {
      self.typeahead.setValue(self.qs.getParameter('query'))
      self.filters.query = self.qs.getParameter('query')
      var customSearch = self.getCustomSearchLocation(self.qs.getParameter('query'));
      if (customSearch) {
        self.filters.zoom = customSearch.zoom
        self.filters.lng = customSearch.lng
        self.filters.lat = customSearch.lat
      }
    }
    // Update placeholder
    if (self.isMobile) {
      self.$el.find('#location-typeahead').attr('placeholder', 'Find Destination'); // should already be this, but just in case people are being sneaky and changing resolutions a lot
    } else {
      self.$el.find('#location-typeahead').attr('placeholder', 'Map area');
    }


    // Check if there's dates in the past, if so reset them
    var arrive = (self.qs.getParameter('arrive') !== null && typeof self.qs.getParameter('arrive') !== 'undefined')
      ? self.qs.getParameter('arrive') : moment(self.todayDate).format('YYYY-MM-DD')
    var depart = (self.qs.getParameter('depart') !== null && typeof self.qs.getParameter('depart') !== 'undefined')
      ? self.qs.getParameter('depart')
      : moment(self.tomorrowDate).format('YYYY-MM-DD')
    // if it's in the past, reset both dates
    if (depart < moment(self.tomorrowDate).format('YYYY-MM-DD') || arrive < moment(self.todayDate).format('YYYY-MM-DD')) {
      self.filters = self.getDefaultFilters()
      self.filters.arrive = moment(self.todayDate).format('YYYY-MM-DD')
      self.filters.depart = moment(self.tomorrowDate).format('YYYY-MM-DD')
      self.pushNewState(self.filters);
    }

    // Init date selector
    self.$dateSelectorEl = self.$el.find('.date-selector')

    self.$dateSelectorEl.daterangepicker(
      {
        autoApply: true,
        minDate: self.todayDate,
        maxDate: self.maxDate,
        parentEl: self.$dateSelectorEl.parent(),
        locale: {
          format: 'DD MMM',
        },
      },
      function (startDate, endDate) {
        // Date selection changed
        self.$el
          .find('.date-range-picker')
          .removeClass('empty')
          .text(startDate.format('DD MMM') + ' – ' + endDate.format('DD MMM'))
        self.$el.find('.arrive.input').val(startDate.format('YYYY-MM-DD'))
        self.$el.find('.depart.input').val(endDate.format('YYYY-MM-DD'))

        self.triggerResearch(true, true) // when booking context changes, we want to update prices
        // Clear stored prices and perform search.
        //clearStoredPrices()
        //doSearch(mapFiltersToApi(getFilters()), true)
      },
    )

    // Date picker events
    self.$dateSelectorEl.on('show.daterangepicker', function () {
      self.$el.find('.date-selector').addClass('open')
      self.$mobileFiltersEl.hide()
    })

    self.$dateSelectorEl.on('hide.daterangepicker', function () {
      self.$el.find('.date-selector').removeClass('open')
      self.$mobileFiltersEl.hide()
    })
    // handle result item hover

    // NOTE When hovering a result list item, highlight corresponding map marker
    $(document).on(
      {
        mouseenter: function () {
          // Code to run when mouse enters the element
          const propertyCode = $(this).attr('data-property-code')
          self.$mapEl.find(`.marker[data-property-code="${propertyCode}"]`).addClass('active')
        },
        mouseleave: function () {
          // Code to run when mouse leaves the element
          const propertyCode = $(this).attr('data-property-code')
          self.$mapEl.find(`.marker[data-property-code="${propertyCode}"]`).removeClass('active')
        },
      },
      '.results-container .result',
    )

    // NOTE When hovering a map marker, highlight corresponding result list item.
    $(document).on(
      {
        mouseenter: function () {
          // Code to run when mouse enters the element
          const propertyCode = $(this).attr('data-property-code')
          self.$resultsContainerEl.find(`.result[data-property-code="${propertyCode}"]`).addClass('active')
        },
        mouseleave: function () {
          // Code to run when mouse leaves the element
          const propertyCode = $(this).attr('data-property-code')
          self.$resultsContainerEl.find(`.result[data-property-code="${propertyCode}"]`).removeClass('active')
        },
      },
      '.marker',
    )

    // STATE handle popstate
    // When the user presses back, research if there's a query string, or just reset to the initial search if not
    // TODO Implement this for back clicks
    window.onpopstate = function (event) {
      self.setFiltersFromUrl()
      self.performSearch(true)
    }

    // Desktop filters column layout
    // TODO Handle columns layout with CSS: https://developer.mozilla.org/en-US/docs/Web/CSS/columns
    self.$el.find('.desktop-filters .grouped.fields[data-fields-count]').each(function (i, el) {
      const fields = $(el)
      if (fields.attr('data-fields-count') > 5) {
        fields.addClass('as-columns')
      }
    })

    self.searchForm.el.find('.mobile-filters .ui.checkbox, .desktop-filters .ui.checkbox').checkbox({
      onChange: function () {
        const $this = $(this)
        const isChecked = $this.parent('.ui.checkbox').checkbox('is checked')
        const name = $this.attr('name')
        const value = $this.attr('value')

        // sync mobile and desktop checkboxes
        let matchingCheckboxes = self.searchForm.el.find(`input[name="${name}"][value="${value}"]`)
        matchingCheckboxes.each(function () {
          if (isChecked) {
            $(this).parent('.ui.checkbox').checkbox('set checked')
          } else {
            $(this).parent('.ui.checkbox').checkbox('set unchecked')
          }
        })

        // uncheck other 'pets' checkboxes (i.e. treat like radio buttons)
        if (name === 'pets[]') {
          let otherPetsCheckboxes = self.searchForm.el.find(`input[name="${name}"]`).not(`[value="${value}"]`)
          otherPetsCheckboxes.each(function () {
            $(this).parent('.ui.checkbox').checkbox('set unchecked')
          })
        }
      },
    })

    self.$mobileFiltersAccordionEl = self.$el.find('.mobile-filters .ui.accordion')
    self.$mobileFiltersScrollerEl = self.$el.find('.mobile-filters .scroller')
    self.$mobileFiltersAccordionEl.accordion({
      onChange: function () {
        if (self.$mobileFiltersAccordionEl.height() > self.$mobileFiltersScrollerEl.height()) {
          self.$mobileFiltersEl.addClass('scrollable')
        } else {
          self.$mobileFiltersEl.removeClass('scrollable')
        }
      },
    })

    //fixing the bug for hiding the guest mobile fitlers staying open
    self.$el.find('.guest-selector').click(function (e) {
      e.preventDefault()
      //console.log('the guest selector is clicked');
      self.$mobileFiltersEl.hide()
    })


    self.$el.find('.mobile-filters-button').click(function (e) {
      e.preventDefault()
      self.$mobileFiltersEl.toggle()
    })

    self.$el.find('.park-type-button').each(function (i, el) {
      $(el).popup({
        popup: self.$el.find('.park-type-filters'),
        on: 'click',
        position: 'bottom center',
        lastResort: 'bottom center',
      })
    })

    self.$el.find('.park-features-button').each(function (i, el) {
      $(el).popup({
        popup: self.$el.find('.park-features-filters'),
        on: 'click',
        position: 'bottom center',
        lastResort: 'bottom center',
      })
    })

    self.$el.find('.experiences-button').each(function (i, el) {
      $(el).popup({
        popup: self.$el.find('.experiences-filters'),
        on: 'click',
        position: 'bottom center',
        lastResort: 'bottom right',
      })
    })
    self.$el.find('.park-state-button').each(function (i, el) {
      $(el).popup({
        popup: self.$el.find('.park-state-filters'),
        on: 'click',
        position: 'bottom center',
        lastResort: 'bottom right',
      })
    })

    self.filtersBeingApplied = false;
    self.$el.find('.apply-filters-button').click(function (e) {
      e.preventDefault()

      if ($(e.currentTarget).parent().hasClass('park-state-filters')) {
        self.filtersBeingApplied = true;
      }
      self.applyFilters() // Sets self.filters
      self.$mobileFiltersEl.toggle()
      self.pushNewState(self.filters)
      self.updateFilterButtons()
      self.triggerResearch(true, false) // Applying just filters doesn't require an API call
    })


    // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
    dom.i2svg()



    self.typeahead.events.subscribe('LocationTypeahead: selected', function (result) {
      // If there user's on a parks > state dropdown link with /state on the end, and they've searched something - remove the state
      self.removeStatesFromUrl()

      if (result.isLocation) {
        // move map with optimization
        self.typeahead.optimizer.getCachedPlaceDetails(
          self.typeahead.dbsPlacesService,
          {
            placeId: result.id,
            fields: ['geometry', 'types', 'name'],
          },
          function (place) { self.handleTypeheadPlaceResult(place) }
        );
        self.typeahead.hideResults()
      }

      // If the result is a direct park, direct the user there with their query string intact
      if (result.isPark) {
        let currentSearchQuery = window.location.search;
        let parkUrl = result.url;
        window.location = window.location.origin + parkUrl + currentSearchQuery;
      }
    })

    // When guests are updated, clear the prices and research parks to update priceso
    // Special event that doesn't update state in guest-selector.js, but just alerts us that it's changed to handle here
    window.dbs.globalEvents.subscribe('guestselector:updated_parkmap', function (data) {
      self.triggerResearch(true, true)
    })

    // Map move subscription to re-search parks based on the maps location

    // Now date picker / search bar etc are set up, set the filters from the url
    self.setFiltersFromUrl()
    self.populateInitialMap()
    self.$el.css('opacity', 1)

    // Everything is set up, do initial search
    //doInitialSearch()
    self.map.addListener(
      'bounds_changed',
      self.debounce(function () {

        //const bounds = self.map.getBounds()
        //console.log('Map bounds changed', bounds.toString())

      }, 250),
    ) // Will only log once every 250ms at most

    // Listen for map movement (panning)
    self.map.addListener(
      'center_changed',
      self.debounce(function () {
      }),
      250,
    )

    window.zoomTimeout = false;
    self.map.addListener('zoom_changed', function () {
      // Refresh left side based on what is visible on the map
      if (!window.zoomTimeout) {
        window.zoomTimeOut = setTimeout(() => {
          self.updatePricingPostFilter();
          window.zoomTimeout = false;
        }, 600);
      }
    });// Listen for any movement end (panning or zooming)
    self.idlesBeforeQueryClear = 0;

    self.map.addListener(
      'idle',
      self.debounce(function () {
        // Refresh left side based on what is visible on the map
        self.updateListFromMapMarkers();
        if (self.isGeoLocationSearch) {
          self.idlesBeforeQueryClear = 3;
        }
        if (self.idlesBeforeQueryClear >= 2) {
          if (self.filters.query != '') {
            self.filters.query = '';
          }
          //Comment out this part of code as it always clears the search filter after the 3rd search is done
          //self.typeahead.el.find('.clear-button').trigger('click');
          self.idlesBeforeQueryClear = 0;
        } else {
          self.idlesBeforeQueryClear += 1;
        }
      }),
      250,
    )

    $('.map-canvas').click(function (event) {
      // If clicked marker or infobox, do nothing
      if (event.target.closest('.marker') || event.target.closest('.infoBox')) {
        return
      }

      self.infobox.close()
      $('.marker').removeClass('active')
    })
    self.isFirstLoad = true;
    if (self.qs.getParameter('experiences') != '' || self.qs.getParameter('features') != '' || self.qs.getParameter('state') != '') {
      // First load has experiences/features, special case to handle
      window.dbs.globalEvents.subscribe('performInitialExperienceFilter', function () {
        window.setTimeout(function () {
          self.applyFilters() // Sets self.filters
          self.pushNewState(self.filters)
          self.updateFilterButtons()
          self.triggerResearch(true, false) // Applying just filters doesn't require an API call
        }, 500);
      });
      //
    }
    $('body').on('click', (e) => {
      if (self.isMobile && self.$mobileFiltersEl.is(':visible')
        && !$(e.target).hasClass('mobile-filters-button')
        && !$(e.target).closest(self.$mobileFiltersEl).length) {
        self.$mobileFiltersEl.toggle();
      }
    })
  }
  self.moveMapFromFilters = () => {
    self.map.setOptions({
      center: new google.maps.LatLng(self.filters.lat, self.filters.lng),
      zoom: self.filters.zoom
    });
  }

  // Tries to figure out the best possible zoom level for something
  self.getZoomByPlaceType = (place) => {
    const currentSearchTerm = self.typeahead.selectedItem.label;
    const type = place.types[0]; // Consider only the first type
    switch (type) {
      case 'country':
      case 'administrative_area_level_1':
        // State or  big area, try custom search - if not, 7
        return (self.getCustomSearchLocation(currentSearchTerm)) ? self.getCustomSearchLocation(currentSearchTerm).zoom : 7;
      case 'colloquial_area': // local area
      case 'locality': // City
      case 'political': // e.g. Sydney CBD for example
      case 'tourist_attraction': // e.g. Sydney harbour bridge
      case 'point_of_interest':
      case 'establishment': // a local place, e.g. newcastle council
        return (self.getCustomSearchLocation(currentSearchTerm)) ? self.getCustomSearchLocation(currentSearchTerm).zoom : 8;
      default:
        return (self.getCustomSearchLocation(currentSearchTerm)) ? self.getCustomSearchLocation(currentSearchTerm).zoom : 8;
    }
  }
  self.getCustomSearchLocation = (result) => {
    // This is used generically by a few result types (rip no typescript)
    // Check if its a typeahead
    if (typeof result === 'undefined') {
      return false;
    }
    let searchTerm = '';
    if (result.hasOwnProperty('label')) {
      searchTerm = result.label
    } else if (result.hasOwnProperty('name')) {
      searchTerm = result.name
    } else {
      // or just a string
      searchTerm = result;
    }
    switch (searchTerm) {
      case 'Northern Territory':
      case 'northern-territory':
      case 'Northern Territory, Australia':
        return {
          lat: -19.462359376860196,
          lng: 134.2093219188361,
          zoom: 6
        }
      case 'new-south-wales':
      case 'New South Wales':
      case 'New South Wales, Australia':
        return {
          lat: -33.927886324872276,
          lng: 144.549253625,
          zoom: 6
        }
      case 'victoria':
      case 'Victoria':
      case 'Victoria, Australia':
        return {
          lat: -36.63293740276885,
          lng: 145.09341093750004,
          zoom: 7
        }
      case 'western-australia':
      case 'Western Australia':
      case 'Western Australia, Australia':
        return {
          lat: -25.03171398076943,
          lng: 124.154366,
          zoom: 5
        }
      case 'tasmania':
      case 'Tasmania':
      case 'Tasmania, Australia':
        return {
          lat: -41.42285637223949,
          lng: 146.77380612312308,
          zoom: 7
        }
      case 'australian-capital-territory':
      case 'Australian Capital Territory':
      case 'Australian Capital Territory, Australia':
        return {
          lat: -35.534468214705704,
          lng: 149.3583609887766,
          zoom: 8
        }
      case 'queensland':
      case 'Queensland':
      case 'Queensland, Australia':
        return {
          lat: -21.347741407938678,
          lng: 144.949253625,
          zoom: 6
        }
      case 'south-australia':
      case 'South Australia':
      case 'South Australia, Australia':
        return {
          lat: -31.926409147132446,
          lng: 135.51084921981132,
          zoom: 6
        }
      case 'Australia':
        return {
          lat: self.defaultCenterLocation.lat,
          lng: self.defaultCenterLocation.lng,
          zoom: self.defaultZoomLevel
        }
      default:
        return false;
    }
  }

  self.removeStateFirstAttempt = 0;
  self.removeStatesFromUrl = () => {
    // basically set window.state
    if (self.removeStateFirstAttempt <= 2) { // This will fire twice
      self.removeStateFirstAttempt += 1;
    } else {
      if (self.getStateUrlArray().some(state => window.location.pathname.includes(state))) {
        //console.log('removing state from url')
        const url = new URL(window.location.href);
        //url.pathname = self.isDhpTheme ? '/caravan-parks' : '/parks';
        // Clear the default state filter as well, unless the user has added additional ones themselves already
        if (!self.isMobile) { //
          if (!self.filters.states.includes('|')) {
            // Single state, check if it's the one from the URL
            if (window.location.pathname.includes(self.getStateRouteNameFromFilterValue(self.filters.states))) {
              // Definitely does, clear it out
              self.$el.find('input[name="parkState[]"][value="' + self.filters.states + '"]').prop('checked', false);
              self.filters.states = '';
              self.updateFilterButtons();
            }
            // uncheck states
            self.applyFilters()
            self.performSearch();
          }
        }
        url.pathname = '/parks';
        // Push the new URL to history
        url.searchParams.forEach((val, key) => {
          // Add a Property
          if (!self.filters.hasOwnProperty(key)) {
            Object.defineProperty(self.filters, key, { value: self.qs.getParameter(key), writable: true, configurable: true, enumerable: true });
          }
        });

        history.pushState({ filters: self.filters }, $(' head title').html(), url + '?' + $.param(self.filters))
      }
    }
  }
  self.handleTypeheadPlaceResult = (place) => {
    self.filters.query = place.hasOwnProperty('label') ? place.label : place.name;
    self.isGeoLocationSearch = false;
    const customSearchLocation = self.getCustomSearchLocation(place)
    if (customSearchLocation !== false) {
      self.filters.lat = customSearchLocation.lat
      self.filters.lng = customSearchLocation.lng
      self.filters.zoom = customSearchLocation.zoom

      const newlatlng = new google.maps.LatLng(self.filters.lat, self.filters.lng);
      self.map.setZoom(self.filters.zoom); // Default zoom if viewport is not available
      self.map.setCenter(newlatlng);
      // if (place.geometry.viewport) {
      //self.map.fitBounds(place.geometry.viewport); // This is proving hard to fight against, big searches like "Western Australia" show the whole dang map, so we intercept them
      //self.map.setZoom(self.getZoomByPlaceType(place)); // force zoom out for bounds anyway
      //}
    } else {
      // Handle something normal that we don't want to handle in a specific way, that doesn't have a viewport
      self.filters.lat = place.geometry.location.lat()
      self.filters.lng = place.geometry.location.lng()
      self.filters.zoom = self.getZoomByPlaceType(place);

      const newlatlng = new google.maps.LatLng(self.filters.lat, self.filters.lng);

      self.map.setZoom(self.filters.zoom); // Default zoom if viewport is not available
      self.map.setCenter(newlatlng);
      //self.performSearch(true); // Location search, so we want to re-order

    }
    // If mobile, we want to trigger a re-search so that it gets filtered by location
    // if desktop

    self.updateParkTileDistanceAndOrder(); // update the list, otherwise nothing really happens because we have no pins to base things off
    self.pushNewState(self.filters);

  }

  self.updateMapUrlParameters = () => {
    // Update URL with new map center and zoom level
    let newFilters = self.filters
    let centre = self.map.getCenter()
    newFilters.lat = centre.lat()
    newFilters.lng = centre.lng()
    newFilters.zoom = self.map.getZoom()
    self.removeStatesFromUrl();
    self.pushNewState(newFilters)
  }

  self.getVisibleMarkers = (map, markers) => {
    const bounds = map.getBounds()
    if (!bounds) return [] // Map might not be initialized yet

    return markers.filter((marker) => {
      return bounds.contains(marker.position)
    })
  }

  self.debounce = (func, delay) => {
    let timeoutId
    return function (...args) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func.apply(this, args), delay)
    }
  }

  /*
  self.viewToggleButtons = self.el.find('.js-view-toggle')
  self.viewToggleButtons.each((i, el) => {
    $(el).click((event) => {
      console.log('click', event.currentTarget)
      self.el.toggleClass('show-full-map')
    })
  })
  */
  self.initialMapLoad = true

  self.updateListFromMapMarkers = () => {
    // Refresh left side based on what is visible on the map
    //const center = self.map.getCenter()
    //const zoom = self.map.getZoom()
    //self.currentZoom = zoom
    //self.currentCenter = center
    //console.log('Map stopped moving. New center:', center.lat(), center.lng(), 'New zoom:', zoom)

    let visibleMarkers = self.getVisibleMarkers(self.map, self.markers)
    let visibleProperties = visibleMarkers.map((marker) => {
      //console.log($(marker.targetElement).find('.marker').attr('data-property-code'))
      return $(marker.targetElement).find('.marker').attr('data-property-code')
    })
    if (self.isMobile) {
      visibleProperties = self.getFilteredParkCodes();
    }
    //console.log('Visible properties on map:', visibleProperties)

    self.updateParkTiles(visibleProperties) // just a list of codes, no specific order
    self.updateMapUrlParameters()
    self.updateSearchStats(visibleMarkers.length, self.populateMap_properties.length)

    if (window.scrollY > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
  self.$featuredParks = self.$el.find("#no_results_featured_parks")
  self.renderFeaturedParks = () => {
    if (window.featuredParks.length >= 1) {
      const featuredParksFragment = new DocumentFragment()
      const featuredParks = window.populateMap_properties.filter(x => window.featuredParks.includes(x.code));
      const template = document.createElement('template')
      featuredParks.forEach((parkInfo) => {
        const imageUrls = parkInfo.images.map((image) => self.changeImageCropParameters(image.url))
        const pricingDetails = self.parkTileDetailsTemplate({
          Prices: {
            Message: parkInfo.pricing.message,
            TotalCabinPrice: self.roundPricing(parkInfo.pricing.totalCabinPrice),
            TotalSitePrice: self.roundPricing(parkInfo.pricing.totalSitePrice),
            Guests: $('.total.guests.input').val(),
            GuestsLabel: 'Guests',
            Nights: 2, // TODO Calculate this
            NightsLabel: 'Nights',
          },
        })

        let distance = (self.qs.getParameter('query') !== null && self.qs.getParameter('query') != '') ? `${parkInfo.distanceKm}km` : false

        let parkName = parkInfo.brands.includes('Discovery Parks') ? 'Discovery Parks - ' + parkInfo.name : parkInfo.name;
        template.innerHTML = self.parkTileTemplate({
          PropertyCode: parkInfo.code,
          ImageUrls: imageUrls,
          PropertyUrl: '/parks/permalink/' + parkInfo.code,
          PropertyName: parkName,
          State: parkInfo.state,
          StateLower: parkInfo.state.toLowerCase(),
          Town: parkInfo.area,
          Distance: distance,
          OriginalPropertyName: parkInfo.name,
          //Restrictions: [{
          //HoverText: '',
          //DisplayName: '',
          //ImageUrl: ''
          //}],
          Description: '',
          DisplayRating: Boolean(parkInfo.reviews),
          OverallRating: parkInfo.reviews?.overallRating || '',
          ReviewCount: parkInfo.reviews?.reviewCount || '',
          PricingDetails: pricingDetails,
          HasDogFriendly: self.checkDogFriendly(parkInfo.code),
          HasPool: self.checkHasPool(parkInfo.code, parkName),
        })
        featuredParksFragment.append(template.content)
      })

      self.$featuredParks.append(featuredParksFragment);
    }
  }
}
